import { render, staticRenderFns } from "./BannedWordIcon.vue?vue&type=template&id=578f506a&scoped=true"
import script from "./BannedWordIcon.vue?vue&type=script&lang=js"
export * from "./BannedWordIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f506a",
  null
  
)

export default component.exports